/**
 * The zoom menu, as numbers.
 *
 * Our zoom 1 is "the whole zone, fitted to the stage" rather than a physical
 * 100 %, so the menu's first entry says both: `100% (Uklopi)`. Everything else
 * is Zazzle's ladder, and the − / + buttons walk that same ladder instead of
 * adding a quarter each time — which is why stepping up from 90 % lands on
 * 100 % and not on 115 %.
 */

export const ZOOM_MIN = 0.25;
export const ZOOM_MAX = 4;

/** Ascending, for the − / + walk. */
export const ZOOM_STEPS: readonly number[] = [0.25, 0.5, 0.75, 0.9, 1, 1.25, 1.5, 2, 2.5, 3, 4];

/** The menu, in Zazzle's order: the fit entry first, then the ladder. */
export const ZOOM_MENU: readonly number[] = [1, 0.5, 0.75, 0.9, 1.25, 1.5, 2, 2.5, 3];

export function formatZoom(zoom: number): string {
  return `${Math.round(zoom * 100)}%`;
}

/** The next rung up or down, clamped; never returns the rung it was given. */
export function nextZoom(current: number, direction: 1 | -1): number {
  if (direction > 0) {
    for (const step of ZOOM_STEPS) {
      if (step > current + 1e-6) return step;
    }
    return ZOOM_MAX;
  }
  for (let i = ZOOM_STEPS.length - 1; i >= 0; i -= 1) {
    const step = ZOOM_STEPS[i]!;
    if (step < current - 1e-6) return step;
  }
  return ZOOM_MIN;
}

/** Ctrl+wheel and pinch produce a continuous factor; this keeps it in range. */
export function clampZoom(zoom: number): number {
  return Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(zoom * 1000) / 1000));
}
